import { useEffect, useState } from "react";
import '../auth/SignIn.scss';
import { Auth } from 'aws-amplify';
import { allowedToEmbbedFrame } from "../../utils/Constants";
import PasswordField from "../auth/PasswordField";
import { ReactComponent as LeftImage } from "../../assets/v3/login-right-img.svg"
import PasswordReset from "components/auth/PasswordReset";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CustomSignIn = (props: any) => {
  const [showPasswordReset, setShowPasswordReset] = useState<boolean>();
  const [loading, setLoading] = useState(false);
  const urlParams = new URLSearchParams(props.location.search);
  const appId: any = urlParams.get('appId');
  useEffect(() => {
    document.body.classList.remove('hp-body-homepage-notconnected');
  }, []);

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const handleInputChange = (e: any, prop: string) => {
    setFormData({
      ...formData,
      [prop]: e.target.value
    });
  };
  const signInClick = async () => {
    setLoading(true);
    try {
      await Auth.signIn(formData.email, formData.password);
      if (window.parent) {
        console.log(appId);
        window.parent.postMessage({ 'step': 'signedin' }, allowedToEmbbedFrame(appId));
      }
    }
    catch (error: any) {
      if (error.code && error.code === 'NotAuthorizedException') {
        toast.error('L’adresse e-mail ou le mot de passe est invalide.', { position: toast.POSITION.TOP_CENTER });
      } else if (error.code === "InvalidParameterException" && error.message.indexOf("Member must satisfy regular expression pattern") > -1) {
        toast.error("Mauvais format d'email.", { position: toast.POSITION.TOP_CENTER });
      } else {
        toast.error(error.code, { position: toast.POSITION.TOP_CENTER });
      }
    }
    setLoading(false);
  }

  const forgotPassword = () => {
    setShowPasswordReset(true);
  }

  useEffect(() => {
    document.title = 'HOO POW | Login';
  }, []);

  useEffect(() => {
    // Configuring the notification 
    toast.configure();
  }, []);

  return (<>
    <div className={`ks-form-left ${showPasswordReset && 'passwordResetPage'}`}>
      {!showPasswordReset ? (<>
        <div className="ks-sign-in" slot="sign-in">
          <div className="ks-login">
            <form className='ks-form'>
              <div className="ks-form-group">
                <label className="ks-form-label">E-mail :</label>
                <input type='email' placeholder="Tapez ici votre email" onChange={(e) => handleInputChange(e, 'email')}
                  className="ks-form-control"
                />
              </div>
              <div className="ks-form-group">
                <label className="ks-form-label">Mot de passe :</label>
                <PasswordField placeholder="Tapez ici votre mot de passe" autoComplete="password" onChange={(e: any) => handleInputChange(e, 'password')} className="ks-form-control" />
              </div>
            </form>
            <div className="ks-formBtn">
              <button className="mainBtn" type="submit" onClick={() => { signInClick() }} disabled={formData.email === '' || formData.password === '' || loading}>
                VALIDER
              </button>
              <button className="ks-forgetBtn ks-clickable" onClick={() => { forgotPassword() }} disabled={loading}>
                Mot de passe oublié ? Cliquez-ici
              </button>
            </div>
          </div>
        </div>
      </>) : (<>
        <PasswordReset {...props} successCallback={() => setShowPasswordReset(false)} />
      </>)}
    </div>
    <div className="ks-form-right ks-signin-img">
      <LeftImage />
    </div>
  </>
  );
}
export default CustomSignIn;